module.exports = __webpack_public_path__ + "static/media/departure-icon.5667418b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/departure-icon.svg
// module id = 797
// module chunks = 0